import {
  EstateInputDataFormat_CreateEstateInputDataFormatInput,
  EstateWorkItem,
  useEstateInputData_CreateEstateInputDataAndEstateInputDataFormatMutation,
} from 'queries';

import CreateEstateInputDataFormatModal from 'pages/superadmin-required-info-format/components/create-estate-input-data-format-modal';
import { NotificationSeverity, showAlert, showToast } from 'utils/notification-manager';

type Props = {
  estateWorkItem: EstateWorkItem;
  onClose: () => void;
};

const RequestInfoDocModal = ({ estateWorkItem, onClose }: Props) => {
  const [
    createEstateInputDataAndEstateInputDataFormat,
    { loading: createEstateInputDataAndEstateInputDataFormatExecuting },
  ] = useEstateInputData_CreateEstateInputDataAndEstateInputDataFormatMutation({
    onCompleted: () => {
      showToast({
        message: 'Estate input data created successfully',
        severity: NotificationSeverity.SUCCESS,
      });
      onClose();
    },
    onError: (e) => {
      showAlert({
        message: 'Error creating estate input data: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  const onSubmit = async (formData: EstateInputDataFormat_CreateEstateInputDataFormatInput) => {
    createEstateInputDataAndEstateInputDataFormat({
      variables: {
        input: {
          estateInputDataFormatInput: {
            ...formData,
            estateWorkItemId: estateWorkItem.id,
          },
        },
      },
    });
  };

  return (
    <CreateEstateInputDataFormatModal
      isOneOffRequiredInfoFormat
      title="Request Custom Info/Docs"
      createEstateInputDataFormatExecuting={createEstateInputDataAndEstateInputDataFormatExecuting}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default RequestInfoDocModal;
